function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import 'antd/lib/table/style/index';
import 'antd/lib/button/style/index';
import 'antd/lib/select/style/index';
import 'antd/lib/space/style/index';
import 'antd/lib/badge/style/index';
import 'antd/lib/pagination/style/index';
// import './style.less'

/*
export default genStyleHook('array-cards', (token) => {
  const { componentCls, antCls } = token
  const arrayBase = `${antCls}-formily-array-base`
  return {
    [componentCls]: {
      '&-item': {
        marginBottom: '10px !important',
      },

      [`${arrayBase}-copy`]: {
        marginInlineStart: 6,
      },
    },
  }
}) */

export var genArrayTableStyles = function genArrayTableStyles(prefixCls, token) {
  return [_defineProperty({}, ".".concat(prefixCls), _defineProperty(_defineProperty({
    '&-pagination': _defineProperty({
      display: 'flex',
      justifyContent: 'center'
    }, "&-status-select.has-error", _defineProperty({}, ".".concat(prefixCls, "-status-select"), {
      borderColor: token.colorError + ' !important'
    }))
  }, '.ant-table', {
    table: {
      overflow: 'hidden'
    },
    td: _defineProperty({
      visibility: 'visible'
    }, '.form-item', {
      paddingBottom: 0
    })
  }), "&-sort-helper", {
    background: '#fff',
    border: '1px solid #eee',
    zIndex: '10'
  }))];
};
export default genArrayTableStyles;